import { UserPermissions } from "Infrastructure/Api/permissions";
import { PermissionGuard } from "Infrastructure/Components/PermissionGuard";
import { PaymentPage } from "Payment/Pages";
import { PaymentPaths } from "./Routing";

export const PaymentRoutes = [
	{
		path: PaymentPaths.Index.route,
		element: (
			<PermissionGuard permission={UserPermissions.BankModule.read}>
				<PaymentPage />
			</PermissionGuard>
		),
	},
];
